module.exports = __webpack_public_path__ + "static/media/icon_extension_mp3.38725dfd.svg";